import { useTranslation } from "react-i18next";
import { Skeleton } from "../ui/skeleton";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PaginationControls from "../PaginationControls";
import { formatMoney } from "@/utils/helpers";
import { AppConfig } from "@/utils/AppConfig";
import { User } from "@sentry/react";
import { IoCashOutline } from "react-icons/io5";
import { CiCreditCard1 } from "react-icons/ci";
import { FaPhoneAlt, FaUserAlt, FaWallet } from "react-icons/fa";
import { GiPresent } from "react-icons/gi";
import axios from "axios";
import {  useParams } from "react-router-dom";
import GoBack from "../GoBack";


export default function ClientOrder() {
    const { t, i18n } = useTranslation();
    const [userName, setUserName] = useState<string>('');
    const [userPhone, setUserPhone] = useState<string>('');
    const lang = i18n.language;
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [pageNum, setPageNum] = useState(10);
    const [totalItems, setTotalItems] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const [historyData, setHistoryData] = useState<[]>([])
    const [orderDate, setOrderDate] = useState<string>('');
    const baseURL = import.meta.env.VITE_BASE_URL
    const { id } = useParams()
    async function getClientHistory(id: string, page: number) {

        setLoading(true)
        try {

            const response = await axios.get(`${baseURL}/api/dashboard/clients/${id}/all-orders?locale=${lang}`, {
                params: {

                    page: page,
                    length: pageNum,

                },
                headers: {
                    Authorization: token,
                },
            })


            if (response.data.success == true) {
                setOrderDate(new Date(response.data.orders[0].time * 1000).toLocaleDateString())
                setHistoryData(response.data.orders)
                setTotalItems(response.data.pagination.totalItems);
                setTotalPages(response.data.pagination.totalPages);
                setUserName(response.data.customerData.name);
                setUserPhone(response.data.customerData.phone);
            }
        } catch (error) {
            console.error(error);

        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        if (!id) return;
        getClientHistory(id, currentPage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNum, currentPage]);

    return (
        <>
            <GoBack />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                {userName && (
                    <div className="flex items-center gap-3 p-4 bg-white border rounded-xl shadow-sm">
                        <div className="p-3 bg-blue-100 text-blue-600 rounded-full">
                            <FaUserAlt className="text-lg" />
                        </div>
                        <div className="flex flex-col">
                            <span className="text-xs text-gray-500">{t("clients.name")}</span>
                            <span className="text-sm font-semibold">{userName}</span>
                        </div>
                    </div>
                )}

                {userPhone && (
                    <div className="flex items-center gap-3 p-4 bg-white border rounded-xl shadow-sm">
                        <div className="p-3 bg-green-100 text-green-600 rounded-full">
                            <FaPhoneAlt className="text-lg" />
                        </div>
                        <div className="flex flex-col">
                            <span className="text-xs text-gray-500">{t("clients.phone")}</span>
                            <span dir="ltr" className="text-sm font-semibold">+966 {userPhone}</span>
                        </div>
                    </div>
                )}
            </div>
            <div className=" overflow-x-auto whitespace-nowrap text-center">
                <div

                    className=" w-full text-sm  text-gray-500 bg-white "
                >



                    <div className="text-sm text-left rtl:text-right whitespace-nowrap    text-gray-500 bg-gray-50">

                        <table
                            onClick={(e) => e.stopPropagation()}

                            className="w-full "
                        >
                            <thead className="text-xs text-gray-700 uppercase">
                                <tr>

                                    <>
                                        <th className="px-10 text-center py-3">
                                            {t("clientsTable.orderNumber")}                                            </th>
                                        <th className="px-10 text-center py-3">
                                            {t("clientsTable.orderDate")}                                            </th>
                                        <th className="px-10 text-center py-3">
                                            {t("clientsTable.branchName")}                                            </th>
                                        <th className="px-10 text-center py-3">
                                            {t("clientsTable.paymentDetails")}                                            </th>
                                        <th className="px-10 text-center py-3">
                                            {t("clientsTable.paymentMethod")}                                            </th>
                                        <th className="px-10 text-center py-3">
                                            {t("clientsTable.deliveryType")}                                            </th>
                                        <th className="px-10 text-center py-3">
                                            {t("clientsTable.orderType")}                                            </th>
                                        <th className="px-20 text-center py-3 relative">
                                            {t("clientsTable.status")}

                                        </th>

                                    </>

                                </tr>
                            </thead>
                            {loading ? (
                                <tbody>
                                    {Array.from({ length: 5 }).map((_, index) => (
                                        <tr key={index} className="bg-white border-b">
                                            <td className="px-6 py-4"><Skeleton className="h-4 w-full dark:bg-slate-200" /></td>
                                            <td className="px-6 py-4"><Skeleton className="h-4 w-20 dark:bg-slate-200" /></td>
                                            <td className="px-6 py-4"><Skeleton className="h-4 w-32 dark:bg-slate-200" /></td>
                                            <td className="px-6 py-4"><Skeleton className="h-4 w-24 dark:bg-slate-200" /></td>
                                            <td className="px-6 py-4"><Skeleton className="h-4 w-20 dark:bg-slate-200" /></td>
                                            <td className="px-6 py-4"><Skeleton className="h-4 w-16 dark:bg-slate-200" /></td>
                                            <td className="px-6 py-4"><Skeleton className="h-4 w-20 dark:bg-slate-200" /></td>
                                            <td className="px-6 py-4"><Skeleton className="h-4 w-24 dark:bg-slate-200" /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            ) : (
                                <tbody className="text-center">
                                    {historyData.length !== 0 ? (
                                        historyData.map((data: User) => (
                                            <tr key={data._id} className="bg-white border-b">
                                                <td className="px-6 py-2 flex flex-col">  {data?._id}
                                                    <span >{t("clientsTable.order")}# {data.orderId}</span></td>
                                                <td className="px-6 py-2">{orderDate}</td>
                                                <td className="px-6 py-2">
                                                    {lang === "ar" ? data.branch.nameAR : data.branch.nameEN}
                                                </td>
                                                <td dir="rtl" className="px-6 py-2 text-base">
                                                    {formatMoney(data?.total)} {AppConfig.currency.icon("currentcolor", 13)}
                                                </td>
                                                {!data.cashPaid || !data.networkPaid ? <td className="px-6 py-2 flex flex-col justify-center items-center gap-2">
                                                    <div className="flex justify-center h-full items-center gap-2">
                                                        {data?.paymentType === "cash" || data.paymentMethod === "cash" ? t("clientsTable.cash") : data?.paymentType === "cash-card" ? t("clientsTable.cashCard") : t("clientsTable.creditCard")}
                                                        {data?.paymentType === "cash" || data.paymentMethod === "cash" ? <><IoCashOutline className="text-green-700 text-lg" /></> : data?.paymentType === "cash-card" ? <div className="flex flex-col ms-1"><CiCreditCard1 className="text-blue-700 text-lg" /> <IoCashOutline className="text-green-700 text-lg" /></div> : <><CiCreditCard1 className="text-blue-700 text-lg" /></>}
                                                    </div>
                                                    {data?.usedWalletBalance > 0 && <>
                                                        <div className="flex justify-between gap-1 text-[12px]">
                                                            <h1 className="flex items-center gap-1">{t("clientsTable.walletDiscount")} <FaWallet /></h1>
                                                            <span dir="rtl" className="flex items-center gap-1 text-green-600">{data?.usedWalletBalance} {AppConfig.currency.icon()}</span>
                                                        </div>
                                                    </>}
                                                    {data.pointsDiscount && data.pointsDiscount > 0 && <>
                                                        <div className="flex justify-between gap-1 text-[12px]">
                                                            <h1 className="flex items-center gap-1">{t("ordersBody.points")} </h1>
                                                            <span dir="rtl" className="flex items-center gap-1 text-green-600"> ({data?.usedPoints} <GiPresent size={17} className="mb-1" />  = {data?.pointsDiscount} {AppConfig.currency.icon()})  </span>
                                                        </div>
                                                    </>}
                                                </td> : <>
                                                    <td className="">
                                                        <span className="flex items-center  gap-2 flex-col">
                                                            {data.cashPaid > 0 && <span className="flex items-center gap-1"> {t("clientsTable.cash")} <IoCashOutline className="text-green-700 text-lg" /> <span className="text-green-700 "> {data.cashPaid} {AppConfig.currency.icon()}</span></span>}
                                                            {data.networkPaid > 0 && <span className="flex items-center gap-1"> {t("clientsTable.creditCard")} <CiCreditCard1 className="text-blue-700 text-lg" />  <span className="text-blue-700 ">{data.networkPaid} {AppConfig.currency.icon()}</span></span>}
                                                        </span>
                                                    </td>
                                                </>}
                                                <td className="px-6 py-2">
                                                    <div className="flex items-center justify-center flex-col">
                                                        <span className="h-full font-semibold"> {data.deliveryType === "receiving" ? t("ordersBody.Receiving") : data.deliveryType === "dine-in" ? t("ordersBody.DineIn") : data.deliveryType === "delivery" ? t("ordersBody.delivery") : data.deliveryType === "cashier" ? t("cashierHistoryBody.cashier") : ""}</span>
                                                        {data.dineIn && data.dineIn.floor && data.dineIn.table ? <span>{t("clientsTable.floor")} {data.dineIn?.floor.number} - {t("clientsTable.table")} {data.dineIn?.table.number}</span> : ""}


                                                    </div>

                                                </td>
                                                <td className="px-6 py-2">
                                                    {data.type === "cashier-order" ? t("clientsTable.cashier") : t("clientsTable.onlineMenu")}
                                                </td>
                                                <td className="px-6 py-2">
                                                    <span
                                                        className={`w-fit text-center px-2 py-1 text-xs rounded-full ${data.status === "pending"
                                                            ? "bg-yellow-500 text-white"
                                                            : data.progress === "finished"
                                                                ? "bg-green-300 text-green-900"
                                                                : data.progress === "preparing"
                                                                    ? "bg-blue-600 text-white"
                                                                    : data.progress === "delivering"
                                                                        ? "bg-orange-500 text-white"
                                                                        : data.progress === "delivered"
                                                                            ? "bg-green-700 text-white"
                                                                            : data.status === "accepted"
                                                                                ? "bg-sidebar text-skyblue"
                                                                                : data.status === "paid"
                                                                                    ? "bg-emerald-600 text-white"
                                                                                    : data.status === "returned"
                                                                                        ? "bg-red-600 text-white"
                                                                                        : "bg-red-600 text-white"
                                                            }`}
                                                    >
                                                        {data.status === "pending"
                                                            ? t("clientTableStatus.pending")
                                                            : data.progress === "finished"
                                                                ? t("clientTableStatus.finished")
                                                                : data.progress === "preparing"
                                                                    ? t("clientTableStatus.preparing")
                                                                    : data.progress === "delivering"
                                                                        ? t("clientTableStatus.delivering")
                                                                        : data.progress === "delivered"
                                                                            ? t("clientTableStatus.delivered")
                                                                            : data.status === "accepted"
                                                                                ? t("clientTableStatus.accepted")
                                                                                : data.status === "paid"
                                                                                    ? t("clientTableStatus.paid")
                                                                                    : data.status === "returned"
                                                                                        ? t("clientTableStatus.returned")
                                                                                        : data.status === "rejected"
                                                                                            ? t("clientTableStatus.rejected")
                                                                                            : t("clientTableStatus.cancelled")}
                                                    </span>


                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="px-2 bg-white py-2" colSpan={8}>
                                                {t("clientsTable.noData")}                                                </td>
                                        </tr>
                                    )}
                                </tbody>
                            )}

                        </table>
                    </div>

                </div>
            </div>
            {historyData.length !== 0 && !loading && (
                <PaginationControls
                    pageNum={pageNum}
                    setPageNum={setPageNum}
                    totalItems={totalItems}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages}
                />
            )}
        </>
    )
}
